
import { CLUBS_ORDER } from './constants';

export const parseNestedProfile = (profile: any) => {
    const recursiveParse = (data: any): any => {
        if (typeof data === 'string') {
            try {
                return recursiveParse(JSON.parse(data));
            } catch {
                return data;
            }
        } else if (typeof data === 'object' && data !== null) {
            for (const key in data) {
                data[key] = recursiveParse(data[key]);
            }
        }
        return data;
    };

    return recursiveParse(profile);
};

export const orderProfileForDisplay = (profile: any) => {
    if (!profile || typeof profile !== 'object') return profile;

    const ordered: Record<string, any> = {};
    const priorityKeys = [
        'general',
        'measurements',
        'Ball',
        'driverDistance',
        'sevenIronDistance',
        'pitchingWedgeDistance',
        'username'
    ];

    priorityKeys.forEach((key) => {
        if (profile[key] !== undefined) {
            ordered[key] = profile[key];
        }
    });

    CLUBS_ORDER.forEach((clubKey) => {
        if (profile[clubKey] !== undefined) {
            ordered[clubKey] = profile[clubKey];
        }
    });

    Object.keys(profile).forEach((key) => {
        if (ordered[key] === undefined) {
            ordered[key] = profile[key];
        }
    });

    return ordered;
};
